import { QueryObserverBaseResult, useQuery } from "react-query";
import { queryKeys } from "../../query";
import { createApiWithPath } from "../../client";
import { FieldTypeSearchGroupsResponseData } from "../../types/field-type";

interface FieldTypeSearchGroupsParams {
  q: string;
}

export const getData = async (params: FieldTypeSearchGroupsParams) => {
  const queryParams = new URLSearchParams();
  queryParams.append("search", params.q);

  const { data } = await createApiWithPath(
    "crm",
  ).get<FieldTypeSearchGroupsResponseData>(
    `/field-types/search-groups?${queryParams.toString()}`,
  );

  return data;
};

export const useFieldTypeSearchGroups = (
  params: FieldTypeSearchGroupsParams,
): QueryObserverBaseResult<FieldTypeSearchGroupsResponseData> => {
  const { data, ...props } = useQuery(
    queryKeys.fieldTypeSearchGroups(params),
    () => getData(params),
    {
      enabled: Boolean(params.q) && params.q.trim().length >= 2,
    },
  );
  return { data, ...props };
};
